/* eslint-disable @typescript-eslint/no-explicit-any */
import { Typography } from '@design-system/components/typography/typography';
import { Row } from '@design-system/components/grid/grid';
import { Modal } from '@design-system/components/modal/modal';
import { Button } from '@design-system/components/button/button';

import { DiscountsVM } from '../view-model/discounts.viewModel';
import { F0 } from '@client/new/helpers/types';
import { CreatorLink } from '../../creator/home/components/CreatorLink';

export const CopyLinkModal = (
  p: Pick<DiscountsVM, 'confirmModalMode'> & { onClose: F0 },
) => (
  <Modal
    isOpen={p.confirmModalMode.type !== 'not-started'}
    onClose={p.onClose}
    title="Share your discount"
    centerContent
  >
    <Typography fontWeight="normal">
      {`This link will take your users straight to a checkout page with the
      discount applied. It's ready for use in your email campaigns, social media
      posts, and more! You can always find this link again on the Promotions
      tab.`}
    </Typography>
    <div style={{ textAlign: 'left' }}>
      <CreatorLink
        title="Checkout page link with promo code applied"
        url={
          p.confirmModalMode.type === 'in-progress'
            ? p.confirmModalMode.value
            : ''
        }
      />
    </div>
    <Row justifyCenter gap="m">
      <Button variant="filled" onClick={p.onClose} color="neutral">
        Close
      </Button>
    </Row>
  </Modal>
);
